export default function isBetweenExclusive(startDate: any, endDate: any, day: any){
    return startDate &&  endDate && day > startDate && day < endDate;
}
